import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { BrainCircuit } from 'lucide-react';
export function UniqueMechanism() {
  return <section className="py-16 md:py-24 px-4 bg-gradient-to-b from-brand-dark to-brand-slate/40 relative overflow-hidden" data-id="element-189">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full max-w-lg h-full bg-brand-amber/5 blur-[120px] rounded-full pointer-events-none" data-id="element-190" />

      <div className="max-w-2xl mx-auto relative z-10" data-id="element-191">
        <FadeIn data-id="element-192">
          <div className="flex justify-center mb-8" data-id="element-193">
            <div className="p-4 rounded-full bg-brand-amber/10 border border-brand-amber/20" data-id="element-194">
              <BrainCircuit className="w-8 h-8 text-brand-amber" data-id="element-195" />
            </div>
          </div>
          <h3 className="font-serif text-3xl md:text-4xl text-white text-center mb-8 leading-tight" data-id="element-196">
            Presentamos el Protocolo de <br data-id="element-197" />
            <span className="text-brand-amber italic" data-id="element-198">
              Recableado Dopamínico
            </span>{' '}
            <br data-id="element-199" />
            de Freddy Pimentel.
          </h3>
          <div className="space-y-6 text-lg text-brand-text leading-relaxed text-center" data-id="element-200">
            <p data-id="element-201">
              Este sistema no se basa en "echarle ganas". Se basa en la
              neurociencia del apego. Vamos a interrumpir los circuitos de
              recompensa de tu cerebro que te mantienen encadenado a esa
              persona.
            </p>
            <p className="font-medium text-white bg-white/5 p-6 rounded-xl border border-white/10" data-id="element-202">
              En 21 días, reprogramaremos tu respuesta emocional para que el
              pensamiento de esa persona deje de disparar pánico y empiece a
              generar indiferencia.
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}